import * as z from "zod/v4";
const ProfilePaginationSchema_ = z.object({
    pageSize: z.number().int(),
    nextPageToken: z.number().int(),
});
export const ProfilePaginationSchema = ProfilePaginationSchema_;
//# sourceMappingURL=profile-pagination.js.map